"use client";

import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ClientHistoryHeader from "./ClientHistoryHeader";
import ClientInfoTabs from "./ClientInfoTabs";
import PersonalInfoForm from "./PersonalInfoForm";
import VisaInfoPanel from "./VisaInfoPanel";
import Documents from "./Documents";
import InvoiceDisplay from "./InvoiceDisplay";

function MainProfileHistory() {
  const location = useLocation();
  const [clientData, setClientData] = useState(location.state?.row);

  const [activeTab, setActiveTab] = useState("General Information");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleRefresh = (updatedData) => {
    if (updatedData) {
      setClientData(updatedData);
    }
  };

  if (!clientData) {
    return <p>No client data available.</p>;
  }

  return (
    <div className="md:mx-auto md:p-6">
      <ClientHistoryHeader client={clientData} />
      <ClientInfoTabs activeTab={activeTab} onTabChange={setActiveTab} />

      {activeTab === "General Information" && (
        <div className="p-4 grid grid-cols-1 lg:grid-cols-2 gap-6 bg-[#FFFBF5] border border-[#CAC3BB] rounded-[10px]">
          <PersonalInfoForm client={clientData} />
          <VisaInfoPanel visa={clientData} />
        </div>
      )}
      {activeTab === "Documents" && (
        <div className="p-4 bg-[#FFFBF5] border border-[#CAC3BB] rounded-[10px]">
          <Documents client={clientData} onRefresh={handleRefresh} />
        </div>
      )}

      {activeTab === "Invoices" && (
        <div className="p-4 gap-6 bg-[#FFFBF5] border border-[#CAC3BB] rounded-[10px]">
          <InvoiceDisplay client={clientData} />
        </div>
      )}
    </div>
  );
}

export default MainProfileHistory;
